import { getAuthorizedClients, getloginsandordersdata } from '@/api/login-dashboard';
import moment from 'moment';
const loginDashboard = {
  namespaced: true,
  state: () => ({
    AuthorixedClients: [],
    GeneratedReport: null,
    Status: '',
  }),
  getters: {
    getAuthorizedClients: (state) => state.AuthorixedClients,
    getGeneratedReport: (state) => state.GeneratedReport,
    getStatus: (state) => state.Status,
  },
  actions: {
    fetchAuthorizedClients({ commit }) {
      return new Promise((resolve, reject) => {
        getAuthorizedClients()
          .then((clients) => {
            commit('SET_AUTHORIZED_CLIENTS', clients);
            resolve();
          })
          .catch(() => {
            console.log('error from fetchAuthorizedClients store');
          });
      });
    },
    getLoginsAndOrdersReport({ commit }, payload) {
      commit('SET_STATUS', 'generating');
      return new Promise((resolve, reject) => {
        getloginsandordersdata(payload)
          .then((report) => {
            commit('SET_GENERATED_REPORT', {
              ...report,
              start_date: moment(payload.start_date).format('MM-DD-YYYY'),
              end_date: moment(payload.end_date).format('MM-DD-YYYY'),
            });
          })
          .catch((e) => {
            console.log('error from getTaxReport store', e);
          });
      });
    },
    resetGeneratedReport({ commit }) {
      commit('SET_GENERATED_REPORT', null);
    },
  },

  mutations: {
    SET_AUTHORIZED_CLIENTS: (state, clients) => {
      state.AuthorixedClients = clients ? clients : [];
    },
    SET_GENERATED_REPORT: (state, generatedReport) => {
      state.GeneratedReport = generatedReport;
      state.Status = '';
    },
    SET_STATUS: (state, status) => {
      state.Status = status;
    },
  },
};

export default loginDashboard;
